const headList = [
  {
    headTitle: "請求ID",
  },
  {
    headTitle: "請求先名",
  },
  {
    headTitle: "区分",
  },
  {
    headTitle: "割増金請求金額",
  },
];

const headTitleList = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const formHeadList: any = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
  },
  {
    headTitle: "納付期限",
  },
];

export { headList, headTitleList, formHeadList };
